import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const EMPTY = { origin_city: "", origin_code: "", destination_city: "", destination_code: "", airlines: "",
  category: "domestic", price: 99, trip_type: "One-way economy", image: "", active: true, hot: false, offer_ends: "" };

const FIELDS = [
  ["origin_city", "From city"], ["origin_code", "From code"],
  ["destination_city", "To city"], ["destination_code", "To code"],
  ["airlines", "Airlines (e.g. Delta · United)"], ["price", "Estimated from ($)"],
  ["trip_type", "Trip type"], ["image", "Image URL"],
];

export const RouteDialog = ({ open, onOpenChange, initial, onSave, saving }) => {
  const [form, setForm] = useState(EMPTY);
  useEffect(() => { if (open) setForm(initial ? { ...EMPTY, ...initial } : EMPTY); }, [open, initial]);
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const submit = (e) => { e.preventDefault(); onSave({ ...form, price: Number(form.price) }); };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-h-[90vh] overflow-y-auto border-white/10 bg-[#0D1526] text-white sm:max-w-xl" data-testid="route-dialog">
        <DialogHeader><DialogTitle>{initial ? "Edit route" : "Add route"}</DialogTitle></DialogHeader>
        <form onSubmit={submit} className="grid gap-4 sm:grid-cols-2">
          {FIELDS.map(([k, label]) => (
            <div key={k} className={`space-y-1.5 ${["airlines", "image"].includes(k) ? "sm:col-span-2" : ""}`}>
              <Label htmlFor={k}>{label}</Label>
              <Input id={k} value={form[k]} type={k === "price" ? "number" : "text"} min={k === "price" ? 1 : undefined}
                required={!["airlines", "image"].includes(k)} onChange={(e) => set(k, e.target.value)} data-testid={`route-input-${k}`} />
            </div>
          ))}
          <div className="space-y-1.5">
            <Label>Category</Label>
            <Select value={form.category} onValueChange={(v) => set("category", v)}>
              <SelectTrigger data-testid="route-input-category"><SelectValue /></SelectTrigger>
              <SelectContent>
                <SelectItem value="domestic" data-testid="route-category-domestic">Domestic</SelectItem>
                <SelectItem value="international" data-testid="route-category-international">International</SelectItem>
              </SelectContent>
            </Select>
          </div>
          <div className="flex items-center gap-3 pt-6">
            <Switch checked={form.active} onCheckedChange={(v) => set("active", v)} data-testid="route-input-active" />
            <Label>Show on website</Label>
          </div>
          <div className="flex items-center gap-3">
            <Switch checked={form.hot} onCheckedChange={(v) => set("hot", v)} data-testid="route-input-hot" />
            <Label>Hot deal badge</Label>
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="offer_ends">Offer ends (optional)</Label>
            <Input id="offer_ends" type="datetime-local" value={form.offer_ends} onChange={(e) => set("offer_ends", e.target.value)} data-testid="route-input-offer_ends" />
          </div>
          <button type="submit" disabled={saving} data-testid="route-save-btn"
            className="rounded-full bg-amber-400 py-3 font-bold text-[#070B14] disabled:opacity-60 sm:col-span-2">
            {saving ? "Saving…" : "Save route"}
          </button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
